var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-alert",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.alertStatus,
                  expression: "alertStatus",
                },
              ],
              attrs: { type: "success", text: "" },
            },
            [_vm._v(" " + _vm._s(_vm.msgAlertStatus) + " ")]
          ),
          _c(
            "base-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-card-title",
                    [
                      _vm._v(" Listados Clientes FE "),
                      _c("v-spacer"),
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "mdi-magnify",
                          label: "Buscar",
                          "single-line": "",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.search,
                          callback: function ($$v) {
                            _vm.search = $$v
                          },
                          expression: "search",
                        },
                      }),
                      _c("v-spacer"),
                    ],
                    1
                  ),
                  _c("v-data-table", {
                    staticClass: "elevation-1",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.details,
                      search: _vm.search,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.Estado`,
                          fn: function ({ item }) {
                            return [
                              item.Estado === "H"
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        color: "yellow darken-2",
                                        right: "",
                                      },
                                    },
                                    [_vm._v(" mdi-alpha-h-circle ")]
                                  )
                                : item.Estado === "P"
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        color: "success darken-2",
                                        right: "",
                                      },
                                    },
                                    [_vm._v(" mdi-alpha-p-circle ")]
                                  )
                                : _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        color: "info darken-2",
                                        right: "",
                                      },
                                    },
                                    [_vm._v(" mdi-alpha-d-circle ")]
                                  ),
                            ]
                          },
                        },
                        {
                          key: `item.Activo`,
                          fn: function ({ item }) {
                            return [
                              item.Activo === 1
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        color: "success darken-2",
                                        right: "",
                                      },
                                    },
                                    [_vm._v(" mdi-account-check ")]
                                  )
                                : _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        color: "warning darken-2",
                                        right: "",
                                      },
                                    },
                                    [_vm._v(" mdi-account-cancel ")]
                                  ),
                            ]
                          },
                        },
                        {
                          key: `item.TokenEnterprise`,
                          fn: function ({ item }) {
                            return [
                              _c("TokenCopyIcon", {
                                attrs: { token: item.TokenEnterprise },
                                on: {
                                  "open-dialog": function ($event) {
                                    return _vm.openTokenDialog(
                                      "Enterprise",
                                      item.TokenEnterprise
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: `item.TokenPassword`,
                          fn: function ({ item }) {
                            return [
                              _c("TokenCopyIcon", {
                                attrs: { token: item.TokenPassword },
                                on: {
                                  "open-dialog": function ($event) {
                                    return _vm.openTokenDialog(
                                      "Password",
                                      item.TokenPassword
                                    )
                                  },
                                },
                              }),
                            ]
                          },
                        },
                        {
                          key: `item.Nit`,
                          fn: function ({ item }) {
                            return [
                              _c("v-dialog", {
                                attrs: {
                                  "max-width": "1000",
                                  transition: "dialog-bottom-transition",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "mr-2",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  attrs: {
                                                    color: "info darken-3",
                                                  },
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v(" mdi-information-box ")]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "default",
                                      fn: function (dialog) {
                                        return [
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-toolbar",
                                                {
                                                  staticStyle: {
                                                    "background-color":
                                                      "rgb(204 33 40)",
                                                    color: "white !important",
                                                  },
                                                  attrs: { dark: "" },
                                                },
                                                [
                                                  _vm._v(
                                                    " DATOS FABRICANTE/DISTRIBUIDOR - CLIENTE [" +
                                                      _vm._s(
                                                        item.NombreCompania
                                                      ) +
                                                      "] "
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticStyle: {
                                                        "margin-left":
                                                          "460px !important",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          dialog.value = false
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("mdi-close ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("campo-client", {
                                                attrs: {
                                                  token_enterprise:
                                                    item.TokenEnterprise,
                                                  token_password:
                                                    item.TokenPassword,
                                                  fabricante:
                                                    item.FabricanteSoftware,
                                                  nit: item.Nit,
                                                  razon_social:
                                                    item.RazonSocialDistribuidor,
                                                  distribuidor:
                                                    item.Distribuidor,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ]
                          },
                        },
                        {
                          key: `item.EmailFE`,
                          fn: function ({ item }) {
                            return [
                              _c("v-dialog", {
                                attrs: {
                                  "max-width": "500",
                                  transition: "dialog-bottom-transition",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "mr-2",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  attrs: {
                                                    color: "warning darken-3",
                                                  },
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v(" mdi-email ")]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "default",
                                      fn: function (dialog) {
                                        return [
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-toolbar",
                                                {
                                                  staticStyle: {
                                                    "background-color":
                                                      "rgb(204 33 40)",
                                                    color: "white !important",
                                                  },
                                                  attrs: { dark: "" },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.NombreCompania
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ml-auto",
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          dialog.value = false
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("mdi-close"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "campo-client-email-facturacion",
                                                {
                                                  attrs: {
                                                    token_enterprise:
                                                      item.TokenEnterprise,
                                                    token_password:
                                                      item.TokenPassword,
                                                    email: item.EmailFE,
                                                    emailType: "EmailFE",
                                                  },
                                                  on: {
                                                    "email-updated":
                                                      _vm.onEmailUpdated,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ]
                          },
                        },
                        {
                          key: `item.EmailDelivery`,
                          fn: function ({ item }) {
                            return [
                              _c("v-dialog", {
                                attrs: {
                                  "max-width": "500",
                                  transition: "dialog-bottom-transition",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "mr-2",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  attrs: {
                                                    color: "green darken-2",
                                                  },
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v(" mdi-email ")]
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "default",
                                      fn: function (dialog) {
                                        return [
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-toolbar",
                                                {
                                                  staticStyle: {
                                                    "background-color":
                                                      "rgb(204 33 40)",
                                                    color: "white !important",
                                                  },
                                                  attrs: { dark: "" },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.NombreCompania
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "ml-auto",
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          dialog.value = false
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("mdi-close"),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "campo-client-email-facturacion",
                                                {
                                                  attrs: {
                                                    token_enterprise:
                                                      item.TokenEnterprise,
                                                    token_password:
                                                      item.TokenPassword,
                                                    email: item.EmailDelivery,
                                                    emailType: "EmailDelivery",
                                                  },
                                                  on: {
                                                    "email-updated":
                                                      _vm.onEmailUpdated,
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ]
                          },
                        },
                        {
                          key: `item.InfDocProcesados`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { color: "blue darken-1" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openReportDialog(item)
                                    },
                                  },
                                },
                                [_vm._v(" mdi-file-download ")]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.InfDocPendientes`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { color: "orange darken-3" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openPendingReportDialog(item)
                                    },
                                  },
                                },
                                [_vm._v(" mdi-file-download-outline ")]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.InfCantTransactions`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-2",
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { color: "yellow darken-3" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openReportCantTransactions(
                                        item
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" mdi mdi-file-cabinet ")]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.sincronizarRangos`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-row",
                                { attrs: { justify: "center" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "blue",
                                        small: "",
                                        icon: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openSyncDialog(item)
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("mdi-reload")])],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.ActivarInactivar`,
                          fn: function ({ item }) {
                            return [
                              item.Activo == 1
                                ? _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      staticStyle: {
                                        cursor: "pointer",
                                        "text-align-last": "center",
                                      },
                                      attrs: { color: "red darken-3" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.activeInactiveClients(item)
                                        },
                                      },
                                    },
                                    [_vm._v(" mdi-account-cancel ")]
                                  )
                                : _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      staticStyle: { cursor: "pointer" },
                                      attrs: { color: "success darken-3" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.activeInactiveClients(item)
                                        },
                                      },
                                    },
                                    [_vm._v(" mdi-account-check ")]
                                  ),
                            ]
                          },
                        },
                        {
                          key: `item.Editar`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { cursor: "pointer" },
                                  attrs: { color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openUpdateClientDialog(item)
                                    },
                                  },
                                },
                                [_vm._v(" mdi-pencil ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px" },
              model: {
                value: _vm.dialogUpdateClient,
                callback: function ($$v) {
                  _vm.dialogUpdateClient = $$v
                },
                expression: "dialogUpdateClient",
              },
            },
            [
              _c("show-update-clients", {
                attrs: {
                  client: _vm.selectedClient,
                  "type-environment": _vm.typeEnvironment,
                  "list-technology-provider": _vm.listTechnologyProvider,
                  emisor_client_Id: _vm.emisor_client_Id,
                  client_id: _vm.client_id,
                  client_secret: _vm.client_secret,
                  grant_type: _vm.grant_type,
                  scope: _vm.scope,
                  url_token: _vm.url_token,
                  representation_graphic: _vm.representation_graphic,
                  "id-compania": _vm.selectedClientIdCompania,
                },
                on: { "client-updated": _vm.onClientUpdated },
                model: {
                  value: _vm.dialogUpdateClient,
                  callback: function ($$v) {
                    _vm.dialogUpdateClient = $$v
                  },
                  expression: "dialogUpdateClient",
                },
              }),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "500",
                transition: "dialog-bottom-transition",
              },
              model: {
                value: _vm.tokenDialog,
                callback: function ($$v) {
                  _vm.tokenDialog = $$v
                },
                expression: "tokenDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      staticStyle: {
                        "background-color": "rgb(204, 33, 40)",
                        color: "white !important",
                      },
                      attrs: { dark: "" },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.tokenTitle) + " "),
                      _c(
                        "v-icon",
                        {
                          staticStyle: {
                            "margin-left": "auto",
                            cursor: "pointer",
                          },
                          on: { click: _vm.closeTokenDialog },
                        },
                        [_vm._v("mdi-close")]
                      ),
                    ],
                    1
                  ),
                  _c("v-card-text", [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          "margin-top": "20px",
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "margin-bottom": "20px",
                              "font-size": "16px",
                            },
                          },
                          [_vm._v(_vm._s(_vm.selectedToken))]
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ma-2",
                            attrs: { color: "primary", elevation: "2" },
                            on: { click: _vm.copyToken },
                          },
                          [_vm._v(" Copiar Token ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "700",
                transition: "dialog-bottom-transition",
              },
              model: {
                value: _vm.reportDialog,
                callback: function ($$v) {
                  _vm.reportDialog = $$v
                },
                expression: "reportDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      staticStyle: {
                        "background-color": "rgb(204 33 40)",
                        color: "white !important",
                      },
                      attrs: { dark: "" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.nombreCompania) +
                          " - Generador de informe de documentos procesados "
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-auto",
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.reportDialog = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("processed-docs-filter", {
                    attrs: {
                      id_compania: _vm.idCompania,
                      nombre_compania: _vm.nombreCompania,
                      report_dialog: _vm.reportDialog,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "700",
                transition: "dialog-bottom-transition",
              },
              model: {
                value: _vm.pendingReportDialog,
                callback: function ($$v) {
                  _vm.pendingReportDialog = $$v
                },
                expression: "pendingReportDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      staticStyle: {
                        "background-color": "rgb(204 33 40)",
                        color: "white !important",
                      },
                      attrs: { dark: "" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.nombreCompania) +
                          " - Generador de informe de documentos pendientes "
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-auto",
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.pendingReportDialog = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("pending-docs-filter", {
                    attrs: {
                      id_compania: _vm.idCompania,
                      nombre_compania: _vm.nombreCompania,
                      pending_report_dialog: _vm.pendingReportDialog,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px" },
              on: { input: _vm.handleDialogInput },
              model: {
                value: _vm.showSyncDialog,
                callback: function ($$v) {
                  _vm.showSyncDialog = $$v
                },
                expression: "showSyncDialog",
              },
            },
            [
              _c("synchronize-ranks", {
                ref: "synchronizeRanks",
                attrs: {
                  nombreCompania: _vm.selectedItem.NombreCompania,
                  idCompania: _vm.selectedItem.IdCompania,
                },
                on: { close: _vm.closeSyncDialog },
              }),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: {
                "max-width": "700",
                transition: "dialog-bottom-transition",
              },
              model: {
                value: _vm.reportCantTransactions,
                callback: function ($$v) {
                  _vm.reportCantTransactions = $$v
                },
                expression: "reportCantTransactions",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      staticStyle: {
                        "background-color": "rgb(204 33 40)",
                        color: "white !important",
                      },
                      attrs: { dark: "" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.nombreCompania) +
                          " - Generador de informe cantidad de Transacciones de FE Hiopos "
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ml-auto",
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.reportCantTransactions = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("TransactionsCantFilter", {
                    attrs: {
                      idCompany: _vm.idCompania,
                      nameCompany: _vm.nombreCompania,
                      cleanData: _vm.reportCantTransactions,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-snackbar",
            {
              attrs: { timeout: "3000", top: "", color: "green" },
              model: {
                value: _vm.snackbar,
                callback: function ($$v) {
                  _vm.snackbar = $$v
                },
                expression: "snackbar",
              },
            },
            [_vm._v(" " + _vm._s(_vm.snackbarMessage) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }